module.exports = __webpack_public_path__ + "img/logo-login.db350ceb.svg";